import React, { useEffect, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Tooltip, Upload } from 'antd';
import "../layout/layouts-styles.css";
import { ModalComponent } from "@comps/components"


const BaseUploadFile = (props) => {

  var fileData=props.fileList ? props.fileList : [];

  const [fileList, setFileList] = useState(props.fileList ? props.fileList : [])
  const acceptType=props.accept?props.accept:'.pdf,.doc,.docx,.jpg,.png,.jpeg';
  //============uploading file============
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    fileData=newFileList;
    props.setFileList(newFileList)
  };

  const onPreview = async (file) => {
    const extension = getFileExtension(file);
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension) || (file.type && file.type.startsWith('image/'));

    if (!isImage) {
      const previewUrl = file.url || (file.originFileObj ? URL.createObjectURL(file.originFileObj) : null);
      if (previewUrl) {
        window.open(previewUrl, '_blank');
      }
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const getFileExtension = (file) => {
    if (file.extension) {
      return file.extension.toLowerCase();
    }
    const name = file.name || file.url || '';
    return name.split('.').pop().toLowerCase();
  }
  // ------------------------------------

  return (
    <>
      <Upload
        { ...props }
        listType="picture"
        accept={acceptType}
        fileList={ fileData }
        onChange={ onChange }
        onPreview={ onPreview }
        //defaultFileList={ [...fileList] }
        //className="upload-list-inline"
        multiple={ false }
        beforeUpload={ (file) => {
          return false;
        } }
        style={{cursor:"pointer"}}
      >
        { fileData.length === 1 ? null : <Tooltip title="Drag & Drop or Click to Select file"><Button icon={ <UploadOutlined /> }>Upload</Button> </Tooltip>}
      </Upload>

      <ModalComponent width={ 1000 } open={ previewOpen } title={ previewTitle } footer={ null } onCancel={ handleCancel }>
        <img
          alt="example"
          style={ {
            width: '100%',
          } }
          src={ previewImage }
        />
      </ModalComponent>
    </>
  )
}


export default BaseUploadFile;
